<style lang="scss">
  @import 'css/custom.module.css';
</style>

<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'App',
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = this.$root.$data.THEME.site_name_header;
            }
        },
    }
  }
</script>
